function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeCircleBiodiversity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#5F9375",
    style: {
      stroke: "#5F9375",
      stroke: "color(display-p3 0.3725 0.5765 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6917 11.6359H19.7006M8.41265 21.4827H16.111C18.0103 21.4827 19.8318 20.7282 21.1748 19.3852C22.5178 18.0422 23.2723 16.2207 23.2723 14.3214V11.6359C23.2743 10.8731 23.0327 10.1297 22.5827 9.5138C22.1327 8.89795 21.4977 8.44191 20.7704 8.21212C20.0431 7.98234 19.2614 7.99081 18.5392 8.23632C17.817 8.48183 17.1921 8.95154 16.7556 9.57701L7.15942 23.273",
    stroke: "#5F9375",
    style: {
      stroke: "#5F9375",
      stroke: "color(display-p3 0.3725 0.5765 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2736 11.6348L25.0639 12.0823L23.2736 12.5299M14.322 21.4815V24.167M17.9026 21.2577V24.167M11.6365 21.4815C12.7403 21.4815 13.8173 21.1413 14.721 20.5073C15.6246 19.8734 16.3109 18.9764 16.6866 17.9384C17.0622 16.9005 17.109 15.772 16.8204 14.7065C16.5318 13.6411 15.922 12.6904 15.0739 11.9839",
    stroke: "#5F9375",
    style: {
      stroke: "#5F9375",
      stroke: "color(display-p3 0.3725 0.5765 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleBiodiversity);
export default __webpack_public_path__ + "static/media/project-type-circle-biodiversity.0d324a00eb061147daecf52a559ab8d4.svg";
export { ForwardRef as ReactComponent };